module.exports = __webpack_public_path__ + "media/applications/assets/images/size-info/full_print_woman_tanktop-2de3d2ab97c24bb699663366e156d5d6.png";